import useBaseAPI from './useBaseAPI';

const useSettingsAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const getConfig = async () => {
    try {
      const response = await client('get', '/config');
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getConfigByGroup = async (groupName) => {
    try {
      const response = await client('get', `/config/group/${groupName}`);
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getConfigByKey = async (keyName) => {
    try {
      const response = await client('get', `/config/key/${keyName}`);
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getConfigByGroupAndKey = async (groupName, keyName) => {
    try {
      const response = await client('get', `/config/group/${groupName}/key/${keyName} `);
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const saveConfig = async (payload) => {
    try {
      const response = await client('post', '/config', payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const saveConfigSet = async (payload) => {
    try {
      const response = await client('post', '/config/save/set', payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const saveFile = async (payload) => {
    try {
      const response = await client('post', '/config/file', payload, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    isLoading,
    getConfig,
    getConfigByGroup,
    getConfigByKey,
    getConfigByGroupAndKey,
    saveConfig,
    saveConfigSet,
    saveFile,
  };
};

export default useSettingsAPI;
